// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3seze","label":"Labeled_label__2o3ro","divider":"Labeled_divider__3BoSe"};